module.exports = __webpack_public_path__ + "static/media/aika-icon.936369fe.jpg";